var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #123157;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,28.4c-.7-12.3,10.2-22.6,25.1-19.8,15.5,3.3,13.7,22.4,7.4,32-6.2,8.8-16.6,4.1-14.7-3.4,1.6-5.7,4.4-12.7,3-16.9-.6-1.8-2.1-3-3.9-3.3-7.2-1.2-11.3,8.9-7.7,16.9l-5.2,22.4c0,.3-.1.6-.2,1-.8,5.1-.8,10,0,14.5,0,.3.5.5.7.2,3.2-3.7,5.7-7.9,7.4-12.8.1-.3.2-.7.3-1.1l2.8-10.8c7.4,10.3,25.9,4.3,30.3-11.4,4.1-15,0-27.2-12.7-32.5-3.8-1.6-7.9-2.3-12-2.3-18.3.2-31.8,13.8-28,31.4.2,1.1.6,2.1,1,3.1,1.5,3.2,3.8,5.5,6.8,6.7.7.3,1.5,0,1.7-.8l1.2-3.9c.2-.5,0-1.1-.3-1.5-1.8-2.1-2.8-4.2-3.1-7.7h.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.2c25be1883fb59f6da37851aa2db4953.svg";
export { ForwardRef as ReactComponent };